import { useState, useEffect } from "react";
import SearchHeroTypewriter from "../SearchHeroTypewriter";
import "./styles.css";
import FormModalProjetClient from "../FormModalProjetClient";

export default function HeroHome({ onMetierChange, onVilleChange }) {
  const [showFormJob, setShowFormJob] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [searchValue, setSearchValue] = useState(""); // un seul input
  const [allMetiers, setAllMetiers] = useState([]);
  const [filteredMetiers, setFilteredMetiers] = useState([]);
  const [showMetiers, setShowMetiers] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  // Découper automatiquement métier et ville à partir de searchValue
  useEffect(() => {
    const handler = setTimeout(() => {
      const [metier = "", ville = ""] = searchValue
        .split(",")
        .map((s) => s.trim());
      onMetierChange?.(metier);
      onVilleChange?.(ville);
      if (!metier || metier.length < 2) {
        setShowMetiers(false);
        return;
      }
      if (ville !== "") {
        setShowMetiers(false);
        return;
      }
      const results = allMetiers.filter((m) =>
        m.labelMetier.toLowerCase().includes(metier.toLowerCase())
      );

      setFilteredMetiers(results);
      setShowMetiers(results.length > 0);
    }, 300);

    return () => clearTimeout(handler);
  }, [searchValue, onMetierChange, onVilleChange, allMetiers]);
  useEffect(() => {
    const fetchMetiers = async () => {
      try {
        const res = await fetch(apiUrl + "/api/metiers");
        if (!res.ok) throw new Error("Erreur récupération métiers");
        const data = await res.json();
        setAllMetiers(data);
      } catch (e) {
        console.error(e);
      }
    };

    fetchMetiers();
  }, []);

  return (
    <>
      <section className="hero">
        <div>
          <h1 style={{ margin: 0 }}>Trouvez le bon pro, près de chez vous !</h1>
        </div>
        <div>
          <h3>
            Publiez votre projet gratuitement et recevez des offres en quelques minutes.
          </h3>

        </div>
        <div>
          {!isSearchActive ? (
            <div onClick={() => {
              setIsSearchActive(true);
              setSearchValue("");
              onMetierChange("");
              onVilleChange("");
            }}>
              <SearchHeroTypewriter
                onMetierChange={null}
                onVilleChange={null}
              />

            </div>
          ) : (
            <>
              <div className="search-wrapper">
                <input
                  type="text"
                  value={searchValue}
                  placeholder="Ex: Plombier, Paris"
                  onChange={(e) => setSearchValue(e.target.value)}
                  className="search-input"
                />
                <span
                  className="search-icon"
                  onClick={() => setShowFormJob(true)}
                >
                  🔍
                </span>
                {showMetiers && (
                  <ul className="autocomplete-list">
                    {filteredMetiers.map((metier) => (
                      <li
                        key={metier.idMetier}
                        onMouseDown={() => {
                          setSearchValue(metier.labelMetier);
                          onMetierChange?.(metier.labelMetier);
                          setShowMetiers(false);
                          document.activeElement.blur(); // ferme le clavier mobile
                        }}
                      >
                        {metier.labelMetier}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

            </>
          )}

          <button style={{ marginTop: "15px" }} className="btn-hero" onClick={() => setShowFormJob(true)}>
            Déposer un projet {">"}
          </button>
        </div>
      </section>

      {showFormJob && (
        <FormModalProjetClient onClose={() => setShowFormJob(false)} />
      )}
    </>
  );
}
